import { render, staticRenderFns } from "./VMButton.vue?vue&type=template&id=48324e21&scoped=true&"
import script from "./VMButton.vue?vue&type=script&lang=js&"
export * from "./VMButton.vue?vue&type=script&lang=js&"
import style0 from "./VMButton.vue?vue&type=style&index=0&id=48324e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48324e21",
  null
  
)

export default component.exports